import "./styles/styles.css";
import "@mdi/font/css/materialdesignicons.css";
import "./utils/dayjs";
import { registerPlugins } from "./plugins";
import App from "./App.vue";
import { createApp } from "vue";

const app = createApp(App);

// Nothing awaited before mount: the index.html boot guard only acts while #app is empty and must not see a late failure (ad-blocked vue-matomo).
registerPlugins(app)
  .then(() => app.mount("#app"))
  .catch((error) => console.error("Failed to start app:", error));
